import { useContext, useEffect } from "react";
import MapContext from "../Map/MapContext";
import { calculer } from "../redux/actions";
import { connect } from "react-redux";


const Maille = ({ maille, checkThemes, zIndex = 200, calculer, state }) => {
	const { map } = useContext(MapContext);
	useEffect(() => {
		if (typeof maille !== "undefined" && maille !== "" && maille.ol_uid!==0) {
			map.addLayer(maille);
			/*
			map.getLayers().getArray().forEach(element => {
				console.log(element)
				if (element.getProperties().type === 'MAILLES') {
					map.removeLayer(element);
				}
			});
			*/
			maille.setZIndex(zIndex);

			return () => {
				if (map) {
					map.removeLayer(maille);
				}
			};
		}
		// eslint-disable-next-line
	}, [map, maille, state.theme1, state.theme2, state.theme3]);

	useEffect(() => {
		if (typeof maille !== "undefined" && maille !== "") {
			calculer(state);
		}
		// eslint-disable-next-line
	}, [checkThemes]);
	//console.log(checkThemes)
	return null;
};


function mapStateToProps(state) {
	return {
		checkThemes: state.checkThemes,
		maille: state.maille,
		state: state,
	}
}

export default connect(mapStateToProps, { calculer })(Maille);